/* eslint-disable react/prop-types */

import React, { useContext } from "react";

import { DocumentContext } from "~context/DocumentContext";

import Minus from "~components/svg/Minus";
import Plus from "~components/svg/Plus";
import Tooltip from "~components/svg/Tooltip";
import Cross from "~components/svg/Cross";

const Service = ({
  servicesItem,
  selected,
  focused,
  activateTooltip,
  setActiveTooltip,
  toggleALaCarte,
  fontColor
}) => {
  const { device } = useContext(DocumentContext);

  return (
    <div
      key={servicesItem.text}
      className={`service case-study-page__service case-study-page__service--${fontColor} grid-end-4 xs:grid-end-8 relative block gpu xs:mb-v3 ${
        focused ? `z-30` : ``
      }`}
    >
      <div
        className={`services-page__tooltip services-page__tooltip--curved ${
          focused ? `active` : ``
        } w-full absolute transform-center z-20 text-gold bg-white`}
      >
        <h3
          className={`${
            device && device === `desktop` ? `b1` : `b2`
          } universal-sans`}
        >
          <span>{servicesItem.text}</span>
        </h3>

        <p className="mt-v1 b2 universal-sans">{servicesItem.description}</p>

        <button
          type="button"
          className="services-page__tooltip--cross absolute"
          onClick={() => setActiveTooltip(null)}
        >
          <Cross color="gold" className="" />
        </button>
      </div>

      <button
        type="button"
        className={`services-page__button services-page__button--${
          servicesItem.type
        } w-full relative flex items-center justify-between ${
          selected ? `selected` : ``
        } text-${fontColor}`}
        onClick={() => toggleALaCarte(servicesItem.text)}
      >
        <span className="relative b1 universal-sans">
          {servicesItem.text}
          <div
            role="presentation"
            className="services-page__button__tooltip absolute top-0 z-10"
            onClick={e => activateTooltip(e, servicesItem.text)}
          >
            <Tooltip color="orange" />
          </div>
        </span>

        {(selected && (
          <Minus
            className="services-page__button__plus--small animation-pop relative block"
            color={fontColor}
          />
        )) || (
          <Plus
            className="services-page__button__plus--small animation-pop relative block"
            color={fontColor}
          />
        )}
      </button>
    </div>
  );
};

export default Service;
